var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.enabled
        ? _c(
            "button",
            {
              attrs: { id: "generate-backup-codes" },
              on: { click: _vm.generateBackupCodes }
            },
            [
              _vm._v(
                _vm._s(_vm.t("twofactor_backupcodes", "Generate backup codes"))
              )
            ]
          )
        : [
            _c(
              "p",
              [
                !_vm.codes
                  ? [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.t(
                              "twofactor_backupcodes",
                              "Backup codes have been generated. {used} of {total} codes have been used.",
                              { used: _vm.used, total: _vm.total }
                            )
                          ) +
                          "\n\t\t\t"
                      )
                    ]
                  : [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.t(
                              "twofactor_backupcodes",
                              "These are your backup codes. Please save and/or print them as you will not be able to read the codes again later"
                            )
                          ) +
                          "\n\t\t\t\t"
                      ),
                      _c(
                        "ul",
                        _vm._l(_vm.codes, function(code) {
                          return _c("li", { staticClass: "backup-code" }, [
                            _vm._v(_vm._s(code))
                          ])
                        })
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "button primary",
                          attrs: {
                            href: _vm.downloadUrl,
                            download: "Nextcloud-backup-codes.txt"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.t(
                                "twofactor_backupcodes",
                                "Save backup codes"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          on: { click: _vm.printCodes }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.t(
                                "twofactor_backupcodes",
                                "Print backup codes"
                              )
                            )
                          )
                        ]
                      )
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _c("p", [
              _c(
                "button",
                {
                  class: { "icon-loading-small": _vm.generatingCodes },
                  attrs: { id: "generate-backup-codes" },
                  on: { click: _vm.generateBackupCodes }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.t("twofactor_backupcodes", "Regenerate backup codes")
                    )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("em", [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.t(
                        "twofactor_backupcodes",
                        "If you regenerate backup codes, you automatically invalidate old codes."
                      )
                    ) +
                    "\n\t\t"
                )
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }